/** Generate Audio hover Contextual Creation Rail — downstream
 * `generate_video` quick action; icon from Function Registry.
 * Supports Result-zone hover-bridge (Canonical external Quick Actions).
 *
 * TASK-00584: thin wrapper over the Admin-driven
 * `CanvasResultQuickActionRail` (source `generate_voice`) — whether the
 * action exists at all is Platform Admin config; `disabled` here is only
 * the node-local "audio is stale" precondition. */

import type { MouseEvent as ReactMouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import CanvasResultQuickActionRail from './CanvasResultQuickActionRail'

interface Props {
  disabled?: boolean
  disabledReason?: string
  onQuickCreateGenerateVideo: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

export default function AudioWorkflowRail({
  disabled,
  disabledReason,
  onQuickCreateGenerateVideo,
  onMouseEnter,
  onMouseLeave,
}: Props) {
  const { t } = useTranslation('canvas')
  return (
    <CanvasResultQuickActionRail
      sourceNodeType="generate_voice"
      className="pcv-media-workflow-toolbar--generate-audio"
      railTestId="canvas-generate-audio-workflow-rail"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      plainIcons
      actionHandlers={[
        {
          targetNodeType: 'generate_video',
          tooltip: t('workflowRail.generateVideo'),
          disabled,
          disabledReason,
          testId: 'canvas-generate-audio-quick-generate-video',
          onClick: (e: ReactMouseEvent) => {
            e.stopPropagation()
            onQuickCreateGenerateVideo()
          },
        },
      ]}
    />
  )
}
